import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useGetGenderTypesQuery } from '../../../../services/RegistrationService';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { updateRegistration } from '../../../../services/RegistrationService/registrationSlice/';

const GenderEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const demographics = useAppSelector(state => state.registration.currentRegistration?.demographics) || {};
  const value = demographics.gender || '';
  const { data: genderTypes = [], isLoading } = useGetGenderTypesQuery();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateRegistration({
      demographics: {
        ...demographics,
        gender: e.target.value,
      },
    }));
  };

  return (
    <TextField
      select
      value={value}
      onChange={handleChange}
      size="small"
      label="Gender"
      disabled={isLoading}
      sx={{ width: 205 }}
    >
      <MenuItem value="">
        Select Gender
      </MenuItem>
      {genderTypes.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default GenderEdit;
